// MoneyWorks Blog Filter Functionality

export default function initBlogFilter() {
  const filterButtons = document.querySelectorAll('.mw-filter-btn');
  const blogCards = document.querySelectorAll('.mw-blog-grid .gh-card');

  if (!filterButtons.length || !blogCards.length) {
    return; // Exit if elements don't exist
  }

  function filterPosts(filterType) {
    blogCards.forEach(card => {
      const tagsAttr = card.getAttribute('data-tags');
      if (!tagsAttr) {
        // If no tags attribute, hide the card unless "all" is selected
        card.classList.toggle('hidden', filterType !== 'all');
        return;
      }

      const tags = tagsAttr.toLowerCase().split(',').map(tag => tag.trim());
      
      if (filterType === 'all') {
        card.classList.remove('hidden');
      } else {
        // Check if any tag matches the filter (case-insensitive, exact match using slug)
        const matches = tags.some(tag => {
          const normalizedTag = tag.toLowerCase().trim();
          const normalizedFilter = filterType.toLowerCase().trim();
          // Exact match (using slug)
          return normalizedTag === normalizedFilter;
        });
        
        card.classList.toggle('hidden', !matches);
      }
    });

    // Update active button
    filterButtons.forEach(btn => {
      const btnFilter = btn.getAttribute('data-filter');
      if (btnFilter === filterType) {
        btn.classList.add('active');
      } else {
        btn.classList.remove('active');
      }
    });
  }

  // Add click handlers to filter buttons
  filterButtons.forEach(button => {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      const filterType = button.getAttribute('data-filter');
      filterPosts(filterType);
    });
  });

  // Initialize with "all" filter
  filterPosts('all');
}
